import { h, render, Component } from 'preact';
import { classNames} from '../utils/utils';

class TxrSpinner extends Component {
    state = {
    }


    render() {
        return (
            this.props.show && <div class="txr-spinner-container">
                <img class="txr-spinner" src="/images/running-circle-content.gif" />
            </div>
        )
    }
}

export default TxrSpinner;


